(function() {
  const measureData = {
    /* === BODY MEASUREMENTS === */
    'body-waist': {
      title: 'How to Measure: Waist',
      image: 'https://luxire.com/cdn/shop/files/image-000_b91f2838-a4c3-4484-baa0-5339bc351a1c_480x480.jpg?v=1664503053',
      instruction: 'Hold the measurement tape around your waist. Keep the tape very close to your skin.',
      steps: [
        'Stand naturally — do not suck in your stomach',
        'Find your natural waist (usually at navel level, the narrowest part of your torso)',
        'Wrap the tape around your waist, keeping it level all the way around',
        'The tape should be snug against your skin but not digging in — you should be able to slide a finger underneath'
      ],
      tip: 'Measure over fitted underwear or a thin layer. Do not measure over jeans or thick clothing.'
    },
    'body-hip': {
      title: 'How to Measure: Hip',
      image: 'https://luxire.com/cdn/shop/files/image-001_207cdd21-f408-4e5a-a251-14248a4e0fe5_480x480.jpg?v=1664503053',
      instruction: 'Hold the measurement tape around your hip, keeping it at the middle of your hip. Keep the tape very close to your skin. Do not squeeze too much.',
      steps: [
        'Stand with your feet together',
        'Find the widest part of your hips/seat — this is usually about 7-8 inches below your waist',
        'Wrap the tape around the fullest point, keeping it level and parallel to the floor',
        'Keep the tape snug but not tight — do not compress your body'
      ],
      tip: 'Look in a mirror from the side to make sure the tape is level and not riding up in the back.'
    },
    'body-rise': {
      title: 'How to Measure: Body Rise',
      image: 'https://luxire.com/cdn/shop/files/image-004_1d6d95f0-0dab-4b35-b468-82290d29782e_480x480.jpg?v=1664503053',
      instruction: 'Place the measurement tape around the rise from the top of the desired front waist line to the back of the waist line. The tape held should not be too tight or loose.',
      steps: [
        'Run the tape from your front waist point, down through your crotch, and up to your back waist point',
        'The tape should follow your body\'s contour naturally',
        'Stand naturally — do not lean forward or backward',
        'The tape should be comfortable, not pulled tight into the body'
      ],
      tip: 'This is a critical measurement for comfort. If you prefer higher or lower rise pants, adjust the waist point accordingly.'
    },
    'body-inseam': {
      title: 'How to Measure: Inseam to Floor',
      image: 'https://luxire.com/cdn/shop/files/image-003_59665166-283f-46d8-8851-aecbe4f33221_480x480.jpg?v=1664503053',
      instruction: 'Stand straight on the ground. Measure the length from your crotch to the floor. Do not bend.',
      steps: [
        'Stand straight with your feet shoulder-width apart on a flat, hard surface',
        'Place the end of the tape at your crotch point (where the inseam of pants would meet)',
        'Let the tape fall straight down to the floor along the inside of your leg',
        'Do not bend down — have someone else read the measurement, or mark the tape and read it after'
      ],
      tip: 'Measure barefoot. We will adjust for your desired hem length and shoe height. This gives us the maximum length to work with.'
    },
    'body-outseam': {
      title: 'How to Measure: Outseam to Floor',
      image: 'https://luxire.com/cdn/shop/files/image-002_8d562726-93d0-4616-85a4-2bbd671e20ff_480x480.jpg?v=1664503053',
      instruction: 'Stand straight on the ground. Measure the length from your waist to the floor. Do not bend.',
      steps: [
        'Stand straight on a flat, hard surface',
        'Place the end of the tape at your natural waist on the side of your body',
        'Let the tape fall straight down along the outside of your leg to the floor',
        'Keep the tape close to your body but straight — do not follow the curves of your leg'
      ],
      tip: 'This measurement combined with the inseam helps us calculate the perfect rise and overall proportions.'
    },
    'body-thigh': {
      title: 'How to Measure: Thigh',
      image: 'https://luxire.com/cdn/shop/files/image-005_72e52b82-a2c6-4712-b559-3f52eae83150_480x480.jpg?v=1664503053',
      instruction: 'Measure your thigh holding the tape 2 inches below the crotch. Hold the tape around your thigh keeping it close to your skin.',
      steps: [
        'Stand with your weight evenly distributed on both feet',
        'Place the tape about 2 inches below your crotch — this is the fullest part of your thigh',
        'Wrap the tape around your thigh, keeping it level and perpendicular to your leg',
        'Keep the tape snug against your skin — do not squeeze or leave gaps'
      ],
      tip: 'Measure your dominant leg (usually the right). If you want a slimmer or more relaxed fit through the thigh, note it in Special Instructions.'
    },
    'body-knee': {
      title: 'How to Measure: Knee',
      image: 'https://luxire.com/cdn/shop/files/image-006_8408f155-bdb7-4d1e-af58-11d9a0e2e9f6_480x480.jpg?v=1664503053',
      instruction: 'Hold the measurement tape around your knee, keeping it at the middle of your knee. Keep the tape very close to your skin. Do not squeeze too much.',
      steps: [
        'Stand straight with your leg slightly bent (natural standing position)',
        'Find the center of your kneecap',
        'Wrap the tape around your knee at the center point',
        'Keep the tape level and snug — not tight enough to restrict movement'
      ],
      tip: 'The knee measurement affects how the pant leg drapes. A slightly relaxed knee is more comfortable for sitting.'
    },
    'body-ankle': {
      title: 'How to Measure: Ankle / Cuff',
      image: 'https://luxire.com/cdn/shop/files/image-007_130eff10-7933-4a84-82c5-6f3dd8872438_480x480.jpg?v=1664503053',
      instruction: 'Hold the measurement tape around your ankle. Keep the tape very close to your skin. Do not squeeze too much.',
      steps: [
        'Measure around the ankle bone area — where you want the pants to end',
        'Keep the tape level around your ankle',
        'The tape should be snug but not tight',
        'Consider your preferred trouser opening — a narrower opening is more tapered, wider is more classic'
      ],
      tip: 'For a classic look, the opening should be wide enough to show a little bit of shoe. For a modern slim look, go narrower. Typical range is 8-11 inches circumference.'
    },

    /* === EXISTING PANTS MEASUREMENTS === */
    'pant-waist': {
      title: 'How to Measure: Pant Waist',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-waist-width.jpg?v=1724245562',
      instruction: 'For waist measurement, start by measuring exactly from one end of the waist side seam to the other end.',
      steps: [
        'Lay your pants flat on a hard surface — a table or the floor',
        'Button or clasp the waistband closed',
        'Measure straight across the top of the waistband from one side seam to the other',
        'Keep the tape flat and straight — do not curve it along the waistband shape'
      ],
      tip: 'This is a flat (half) measurement. Do NOT double it. We will work with the exact number you provide. Measure at the top edge of the waistband.'
    },
    'pant-hip': {
      title: 'How to Measure: Pant Hip',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-hip.jpg?v=1724245562',
      instruction: 'Go up ½ inch towards the waist from the fly line point. Perpendicular to that, measure exactly from one side end to the other. If the pants have pleats, measure with the pleats closed and not stretched.',
      steps: [
        'Lay your pants flat on a hard surface',
        'Locate the bottom of the fly/zipper — this is the fly line point',
        'Move up ½ inch from that point toward the waistband',
        'At that level, measure straight across from one side edge to the other',
        'If your pants have pleats, keep them folded naturally — do not stretch them open'
      ],
      tip: 'This is a flat (half) measurement. The hip is the widest part of the seat area. Make sure the pants are lying completely flat with no wrinkles.'
    },
    'pant-front-rise': {
      title: 'How to Measure: Front Rise',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-frontrise.jpg?v=1724245562',
      instruction: 'For front rise measurement, start from the crotch point and go up to the waist.',
      steps: [
        'Lay your pants flat on a hard surface',
        'Locate the crotch point — where the inseam meets the front of the pant',
        'Place the end of the tape at the crotch seam',
        'Measure straight up to the top of the front waistband (at the center front)',
        'Follow the center line of the front panel'
      ],
      tip: 'The front rise determines how high or low the pants sit. Higher rise is more formal and comfortable for sitting. Typical dress pants are 11-13 inches.'
    },
    'pant-back-rise': {
      title: 'How to Measure: Back Rise',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-backrise.jpg?v=1724245562',
      instruction: 'For back rise measurement, start from the crotch point and go up to the waist.',
      steps: [
        'Flip the pants over so the back is facing up',
        'Locate the crotch point — where the inseam meets the back panel',
        'Place the end of the tape at the crotch seam',
        'Measure straight up to the top of the back waistband (at the center back)',
        'The back rise is typically 2-4 inches longer than the front rise'
      ],
      tip: 'The back rise affects coverage and comfort when sitting or bending. A properly proportioned back rise prevents the waistband from pulling down.'
    },
    'pant-inseam': {
      title: 'How to Measure: Pant Inseam',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-inseam.jpg?v=1724245562',
      instruction: 'For inseam length, take the measurement starting from the crotch point to the bottom hem.',
      steps: [
        'Lay one leg of the pants flat, smoothing out any wrinkles',
        'Locate the crotch seam — the point where the inseam meets',
        'Place the end of the tape right at the crotch seam',
        'Measure along the inside seam all the way down to the bottom hem',
        'Keep the tape following the seam line'
      ],
      tip: 'If your reference pants have cuffs, decide whether to measure to the fold or the full length. Let us know in Special Instructions if you want a different length.'
    },
    'pant-outseam': {
      title: 'How to Measure: Pant Outseam',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-outseam.jpg?v=1724245562',
      instruction: 'For pant length, take the measurement of the side seam starting from the waist to the bottom.',
      steps: [
        'Lay the pants flat on a hard surface',
        'Locate the top of the waistband on the side seam',
        'Place the end of the tape at the top of the waistband',
        'Measure down along the outside seam to the bottom hem',
        'Keep the tape following the side seam line'
      ],
      tip: 'Outseam = Front Rise + Inseam (approximately). This cross-check can help you verify your other measurements.'
    },
    'pant-thigh': {
      title: 'How to Measure: Pant Thigh',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-thigh.jpg?v=1724245562',
      instruction: 'Go down 2 inches from the crotch point perpendicularly and measure exactly from one side to the other.',
      steps: [
        'Lay the pants flat on a hard surface',
        'Locate the crotch seam point',
        'Measure down 2 inches from the crotch point along the inseam',
        'At that 2-inch point, measure straight across the thigh from one side edge to the other',
        'Make sure the pant leg is lying completely flat — no wrinkles or folds'
      ],
      tip: 'This is a flat (half) measurement. The thigh width is crucial for comfort. If you want a slimmer or more relaxed fit, note it in Special Instructions.'
    },
    'pant-knee': {
      title: 'How to Measure: Pant Knee',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-knee.jpg?v=1724245562',
      instruction: 'Fold the pant in half, fold it again from the knee level by adjusting the bottom to the crotch. Above 1 inch from the folded part, measure the knee width exactly from one side to the other.',
      steps: [
        'Fold one pant leg so the bottom hem meets the crotch point',
        'The fold line is approximately your knee point',
        'Unfold and measure 1 inch above that fold line',
        'At that point, measure straight across from one side edge to the other',
        'Keep the pant leg lying completely flat'
      ],
      tip: 'This is a flat (half) measurement. The knee width creates the taper profile from thigh to ankle. A narrower knee gives a more modern, tapered look.'
    },
    'pant-bottom': {
      title: 'How to Measure: Bottom Opening',
      image: 'https://luxire.com/cdn/shop/files/ms-pant-bottom.jpg?v=1724245562',
      instruction: 'Fold the pant in half and take the measurement exactly from one side end to the other.',
      steps: [
        'Lay the pant leg flat on a hard surface',
        'Smooth out the bottom hem area',
        'Measure straight across the bottom hem opening from one edge to the other',
        'This is the width of the trouser opening at the ankle/cuff'
      ],
      tip: 'This is a flat (half) measurement. Typical bottom openings: 7-8" for slim/tapered, 8-9" for classic, 9-10" for relaxed. Cuffed pants may need slightly wider openings.'
    }
  };

  const overlay = document.getElementById('measureHelpOverlay');
  const titleEl = document.getElementById('measureHelpTitle');
  const bodyEl = document.getElementById('measureHelpBody');
  const closeBtn = document.getElementById('measureHelpClose');

  function openHelp(key) {
    const data = measureData[key];
    if (!data) return;

    titleEl.textContent = data.title;

    let html = '';
    if (data.image) {
      console.log('[Luxire Measure Help] Loading image for:', key, '→', data.image);
      html += '<img class="measure-help-modal__image" src="' + data.image + '" alt="' + data.title + '" loading="eager" onload="console.log(\'[Luxire] Image loaded:\', this.src)" onerror="console.error(\'[Luxire] Image FAILED:\', this.src); this.alt=\'Image failed to load — URL: \' + this.src">';
    }
    html += '<p class="measure-help-modal__instruction">' + data.instruction + '</p>';
    if (data.steps && data.steps.length) {
      html += '<ol class="measure-help-modal__steps">';
      data.steps.forEach(function(step, i) {
        html += '<li data-step="' + (i + 1) + '">' + step + '</li>';
      });
      html += '</ol>';
    }
    if (data.tip) {
      html += '<div class="measure-help-modal__tip"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg><span>' + data.tip + '</span></div>';
    }

    bodyEl.innerHTML = html;
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeHelp() {
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  // Bind all help buttons
  document.querySelectorAll('.measurement-field__help[data-measure]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      openHelp(this.dataset.measure);
    });
  });

  closeBtn.addEventListener('click', closeHelp);
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeHelp();
  });
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeHelp();
  });
})();
